import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "PSECWGAP",
  title: defineMessage({
    id: "fig.equity.PSECWGAP.title",
    defaultMessage: `Attendance rate by level and wealth`,
  }),
  caption: defineMessage({
    id: "fig.equity.PSECWGAP.caption",
    defaultMessage: `The poorest have hardly any post-secondary education opportunities in low and middle income countries`,
  }),
  source: defineMessage({
    id: "fig.equity.PSECWGAP.source",
    defaultMessage: `GEM Report team analysis based on household surveys`,
  }),
};
